import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import DebugPanel from '../shared/DebugPanel';
import AgentPanel from '../Agent/AgentPanel';
import ErrorBoundary from '../ui/ErrorBoundary';
import HelpDrawer from '../ui/HelpDrawer';
import CommandPalette from '../CommandPalette';
import useGlobalShortcuts from '../CommandPalette/useGlobalShortcuts';
import useUiStore from '../../stores/uiStore';

export default function AppLayout() {
  const { sidebarOpen, sidebarCollapsed } = useUiStore();
  const ml = !sidebarOpen ? 'ml-0' : sidebarCollapsed ? 'ml-[68px]' : 'ml-60';

  // Globale Shortcuts: Cmd+K / Ctrl+K + "g→letter"-Leader
  useGlobalShortcuts();

  return (
    <div className="min-h-screen bg-primary-50/80 dark:bg-slate-950">
      <Sidebar />
      <div className={`transition-all duration-300 ${ml}`}>
        <Header />
        <main className="p-6">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
      <HelpDrawer />
      <AgentPanel />
      <DebugPanel />
      <CommandPalette />
    </div>
  );
}
